import { Alert } from '@britishcouncil/react-solas';
import { useGetOnlinePaymentDiscountQuery } from 'core/hooks/useGetOnlinePaymentDiscountQuery';

export const OnlinePaymentDiscountAdvertMsg = ({ countryId }: { countryId?: number }) => {
  const { onlinePaymentDiscountAvailable, discountPercentage } = useGetOnlinePaymentDiscountQuery(countryId);

  if (!onlinePaymentDiscountAvailable) return null;

  return (
    <Alert type="success" style={{ marginTop: '1rem' }}>
      <p style={{ fontWeight: 'normal' }}>
        Pay online and get <strong>{discountPercentage}</strong> incentive.
      </p>
    </Alert>
  );
};
